const defaultFont = 'var(--font-onest)';

// ----------------------------------------------------------------------

export const STORAGE_KEY = 'theme-settings';

export const defaultSettings = {
    colorScheme: 'dark',
    direction: 'ltr',
    contrast: 'default',
    navLayout: 'vertical',
    primaryColor: 'default',
    navColor: 'integrate',
    compactLayout: false,
    fontFamily: defaultFont,
  };
  